import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { Attribute, AttributeListResponse, AttributeQueryParams, CreateAttribute, UpdateAttribute } from '@frontend/attribute/types';

export class AttributeClient extends APIClient {
    public static readonly endpoint = '/product-api/v1';

    public static async fetchAttributes(queryParams?: ApiQueryParams<DefaultQueryParams & AttributeQueryParams>): Promise<AttributeListResponse> {
        return await this.apiPaginated<AttributeListResponse, DefaultQueryParams & AttributeQueryParams>(`${this.endpoint}/attributes`, queryParams);
    }

    public static async resolveAttributes(ids: string[], field: string = 'id'): Promise<AttributeListResponse> {
        return this.resolve<AttributeListResponse>(`${this.endpoint}/attributes`, ids, field);
    }

    public static async deleteAttributes(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/attributes-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postAttribute(accountId: string, attribute: CreateAttribute): Promise<Attribute> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/attributes`, attribute);
        return await this.handleResponse<Attribute>(response);
    }

    public static async fetchAttribute(accountId: string, attributeId: string): Promise<Attribute> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/attributes/${attributeId}`);
        return await this.handleResponse<Attribute>(response);
    }

    public static async patchAttribute(accountId: string, attributeId: string, attribute: UpdateAttribute): Promise<Attribute> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/attributes/${attributeId}`, attribute);
        return await this.handleResponse<Attribute>(response);
    }

    public static async deleteAttribute(accountId: string, attributeId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/attributes/${attributeId}`);
        return await this.handleVoidResponse(response);
    }

    public static async postIoTSeed(accountId: string, iotId: string, body: { account_id: string }): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/seed`, body);
        return this.handleResponse(response);
    }
}
